import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import SelectDropDown from "../selectdropdown/SelectDropDown";


const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

class HolidayModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    dropDownGetValues(fieldname) {
        let getArray = [];
        const newObj1 = {
            value: "0",
            label: "Select"
        }
        getArray.push(newObj1);

        this.props.globals.globalBranches.map((stumap) => {
            const newObj = {
                value: stumap.id,
                label: stumap.branch_name
            }
            getArray.push(newObj);
        });
        return getArray;
    }

    render() {
        return (
            <Modal {...this.props}
                size="sm" aria-labelledby="example-modal-sizes-title-lg">
                <Modal.Header closeButton >
                    <Modal.Title className="text-center">Mark Holiday</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Row>
                        <Col lg={12} md={12} sm={12}>
                            <h6 style={{ display: "inline" }}>Branch</h6>
                            <p style={{ display: "inline" }}><span className="text-danger">   {this.props.stateData.holidayBranchError}</span></p>
                            <SelectDropDown
                                stateData={this.props.stateData.holidayBranchVal}
                                handleChange={this.props.selecthandleInputChange}
                                name="holidayBranch"
                                options={this.dropDownGetValues("holidayBranch")}
                                placeholderName={'Branch'}
                                dropdownIndicator={{ DropdownIndicator }}
                            />
                        </Col>
                    </Row>

                    <Row>
                        {/* <Col sm={12} className="text-center mt-2">
                            {this.props.stateData.currentStep == 5 ? (<div class="spinner-border text-primary"></div>) : ("")}
                        </Col> */}
                        <Col sm={12} class="text-center">
                            <h6 className="text-center mb-4 mt-3">Are you sure you want to mark as Holiday</h6>
                            <div className="d-flex flex-row justify-content-center">
                                <Button className="btn btn-success text-uppercase px-lg-5 ml-1" onClick={this.props.markHoliday} >Yes</Button>
                                <Button className="btn btn-danger text-uppercase px-lg-5 ml-1" onClick={this.props.onHide}>No</Button>
                            </div>
                            <p className="text-center text-danger mt-2">{this.props.stateData.submitError}</p>
                            <p className="text-center text-danger mt-2">{this.props.stateData.currentStep == 5 ? "Marked as Holiday" : ""}</p>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        )
    }
}

export default HolidayModal
